import {useEffect, useState} from "react"
import {useNavigate, useParams} from "react-router-dom"

import {Accepted} from "./Accepted"
import {Rejected} from "./Rejected"
import {Invalid} from "./Invalid"
import {AcceptedWithSuggestions} from "./AcceptedWithSuggestions"

import {LoadingPage} from "@indebted/components/Loading"
import {affordabilityAssessmentAPI} from "@indebted/api"

function Result() {
	const {secureCode, id} = useParams()
	const navigate = useNavigate()
	const [Component, setComponent] = useState(<LoadingPage />)
	useEffect(() => {
		const components = {
			Accepted: Accepted,
			AcceptedWithSuggestions: AcceptedWithSuggestions,
			Rejected: Rejected,
		}
		affordabilityAssessmentAPI.findBy({secureCode, id}).then((result) => {
			const Component = components[result.Status] || Invalid
			setComponent(<Component {...result} navigate={navigate} secureCode={secureCode} id={id} />)
		})
	}, [secureCode, id, navigate])

	return Component
}

export {Result}
